"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestFunction: function (pageload, uuid, method) { return function (dispatch, getState) {
        var appState = getState();
        console.log("uuid -" + uuid + " || method -" + method);
        if (appState && appState.confirmStatusApplication && pageload == true && method == "PUT") {
            console.log("call put");
            fetch("/v1/apps/" + uuid + "/approve", {
                method: 'PUT'
            })
                .then(function (response) {
                return dispatch({ type: 'RECEIVE_CONFIRMAPPLICATION', message: response.status });
            })
                .then(function (data) {
            })
                .then(function (error) {
            });
            dispatch({ type: 'REQUEST_CONFIRMAPPLICATION' });
        }
        if (appState && appState.confirmStatusApplication && pageload == true && method == "DELETE") {
            console.log("call delete");
            fetch("/v1/apps/" + uuid + "/reject", {
                method: 'DELETE'
            })
                .then(function (response) {
                return dispatch({ type: 'RECEIVE_CONFIRMAPPLICATION', message: response.status });
            })
                .then(function (data) {
                console.log("data -->");
                console.log(data);
            })
                .then(function (error) {
            });
            dispatch({ type: 'REQUEST_CONFIRMAPPLICATION' });
        }
    }; }
};
var unloadedState = { isLoading: false, message: 400 };
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_CONFIRMAPPLICATION':
            return {
                isLoading: false,
                message: 400
            };
        case 'RECEIVE_CONFIRMAPPLICATION':
            return {
                isLoading: true,
                message: action.message
            };
        default: return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=ConfirmStatusApplication.js.map